module.exports = __webpack_public_path__ + "static/media/Workday_Step2a_Image7h.815d11ae.jpg";